function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultimedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 60,
    width: 60,
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 53.418 53.418",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M47.282,5.704H6.136C2.753,5.704,0,8.591,0,12.14v29.139c0,3.549,2.753,6.436,6.136,6.436h41.146 c3.383,0,6.136-2.887,6.136-6.436V12.14C53.418,8.591,50.665,5.704,47.282,5.704z M51.305,41.278 c0.001,2.383-1.804,4.322-4.023,4.322H6.136c-2.219,0-4.023-1.938-4.023-4.322V12.14c0-2.384,1.805-4.322,4.023-4.322h41.146 c2.219,0,4.023,1.938,4.023,4.322V41.278z M22.239,33.18c0.224,0,0.451-0.074,0.677-0.223l8.994-5.902 c0.371-0.243,0.574-0.596,0.558-0.966c-0.017-0.371-0.252-0.703-0.645-0.911l-8.9-4.729c-0.81-0.431-1.617,0.078-1.617,0.973 v10.666C21.305,32.838,21.789,33.18,22.239,33.18z M22.304,21.422L22.304,21.422c0.001-0.082,0.016-0.124,0.017-0.136 c0.018,0.001,0.062,0.009,0.133,0.046l8.9,4.729c0.064,0.034,0.095,0.063,0.108,0.068c-0.013,0.018-0.041,0.05-0.102,0.09 l-8.994,5.902c-0.021,0.014-0.041,0.025-0.058,0.033c-0.003-0.018-0.004-0.04-0.004-0.066V21.422z M45.622,12.687H7.902 c-0.297,0-0.537,0.24-0.537,0.537v26.753c0,0.297,0.24,0.538,0.537,0.538h37.72c0.297,0,0.538-0.241,0.538-0.538V13.224 C46.16,12.927,45.919,12.687,45.622,12.687z M45.086,39.44L45.086,39.44H8.44V13.761h36.646V39.44z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultimedia);
export default __webpack_public_path__ + "static/media/multimedia.7760e889cce5f480f8de967d71514558.svg";
export { ForwardRef as ReactComponent };